export const _sessionStorage = {
  /**
   * セッションストレージからデータを呼び出す
   * @param key
   * @returns {any}
   */
  fetch(key) {
    return JSON.parse(sessionStorage.getItem(key) || "null");
  },
  /**
   * セッションストレージにデータを保存
   * @param key
   * @param data
   */
  save(key, data) {
    sessionStorage.setItem(key, JSON.stringify(data));
  },
  /**
   * セッションストレージのデータを削除
   * @param key
   */
  delete(key) {
    sessionStorage.removeItem(key);
  }
};
